import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Tooltip from "react-tooltip";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  InformationCircleIcon,
  RectangleStackIcon,
} from "@heroicons/react/24/solid";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useGetCarriersCount } from "../../CarrierAgreementMgmt/Carrier/hooks/useGetCarriersCount";
import { PERMISSIONS } from "../../PermissionsConstants";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import DashboardCard2 from "../../../components/DashboardCard2";

const NewCarrierCard = () => {
  //FRANCHISE MODULE NOW
  const { data: carrier, isLoading } = useGetCarriersCount();
  const activeCarrier = Number(carrier?.[0]);
  const inactiveCarrier = Number(carrier?.[1]);

  const totalCarrier = activeCarrier + inactiveCarrier;
  const history = useHistory();

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState(permittedTabs);
  const modulePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_carrier_view;
  const userPermissions = useRecoilValue(permissionsSelector);

  return (
    <>
      {/* {userPermissions.includes(modulePermission) ? ( */}
      <div
        className="flex w-full bg-tabColorDarkBlue lg:p-4 md:p-2 rounded-lg cursor-pointer"
        onClick={() => {
          if (userPermissions.includes(modulePermission))
            RedirectTo({
              urlPath: "/carrieragreementmgmt/carriers",
              history: history,
              usersTabs: usersTabs,
              setSelectedIndex: setSelectedIndex,
            });
        }}
      >
        <DashboardCard2
          text="Carrier"
          count={isLoading ? "..." : totalCarrier}
          image={
            <RectangleStackIcon className="text-white rounded-lg h-7 w-7 p-1" />
          }
          hasAccess={userPermissions.includes(modulePermission)}
        />
        {userPermissions.includes(modulePermission) ? (
          ""
        ) : (
          <div className="relative">
            <Tooltip
              id="carrier"
              place="top"
              effect="solid"
              type="info"
              border={false}
              arrowColor="#3a3b3c"
              // borderColor="#0078d7"
              backgroundColor="#3a3b3c"
              textColor="white"
            />
            <InformationCircleIcon
              data-tip={
                "Contact your System Administrator to secure access to this module."
              }
              data-for="carrier"
              className="h-6 w-6 mr-2 text-white"
            />
          </div>
        )}
      </div>

      {/* ) : ( */}
      {/* <div className="flex w-full bg-tabColorDarkBlue lg:p-4 md:p-2 rounded-lg cursor-pointer" />
      )} */}
    </>
  );
};

export default NewCarrierCard;
